import React from 'react';
import { Link } from 'react-router-dom';
import config from '../../../pages/Config';
import userIcon from "../../../Assets/Images/user.webp"
import wavesImage from "../../../Assets/Images/waves.svg"
import secureLocalStorage from 'react-secure-storage';

const CardStatics = ({ sessionCount , availableDay }) => {

    const users = secureLocalStorage.getItem("credentials");
    return (
        <section className="ps-card ps-card--statics">
            {/* <div className="ps-card__header pb-4">
            <h4>Project Statistics</h4>
        </div> */}
            <div className=" row align-items-center h-100">
                <div className='col-md-4 '>
                    <Link to={`${config.appUrl}profile`}>
                        <div className="ps-block--stat bg-green position-relative shadow-sm">
                            <div className="ps-block__left">
                                <span>
                                    <img src={`${users?.image ? `${config.imageUrl}${users?.image}`  : userIcon}`} alt="" className=' w-100 h-100' />
                                    {/* <i className="icon-user"></i> */}
                                </span>
                            </div>
                            <div className="ps-block__content text-white">
                                <h4 className='text-white'>
                                    {users?.name}
                                </h4>
                                <div className='text-white px-3 py-1 mt-1 d-inline-block bg-black border text-green position-relative rounded-pill fs-6 text-uppercase'>View Profile </div>
                            </div>

                            <img src={wavesImage}
                                alt="" className='cloud-design' />
                        </div>
                    </Link>
                </div>

                <div className='col-md-4 mt-md-0 mt-4'>
                    <Link to={`${config.appUrl}lessons`}>
                        <div className="ps-block--stat bg-black position-relative shadow-sm">
                            <div className="ps-block__left">
                                <span>
                                    <i className="icon-book2"></i>
                                </span>
                            </div>
                            <div className="ps-block__content text-white">
                                <p className='text-white'>All Lessons </p>
                                <h4 className='text-white'>
                                    {sessionCount ? String(sessionCount).padStart(2, '0') : "00"}
                                </h4>
                            </div>

                            <img src={wavesImage}
                                alt="" className='cloud-design' />
                        </div>
                    </Link>
                </div>

                <div className='col-md-4 mt-md-0 mt-4'>
                    <Link to={`${config.appUrl}availability`}>
                        <div className="ps-block--stat bg-black position-relative shadow-sm" style={{ minHeight: '90px' }}>
                            <div className="ps-block__content ps-2">
                                <p className='text-white mb-2'>I'm Available on - </p>
                                <div>
                                    {
                                        availableDay?.slice(0,3)?.map((item, i) => {
                                            return <span key={i} className='badge text-dark bg-light me-1'>{item?.days}</span>
                                        })
                                    }
                                    {
                                        availableDay?.length === 0 &&
                                        <span className='badge text-danger bg-light me-1'>{'Not Available'}</span>
                                    }
                                </div>
                            </div>
                            <img src={wavesImage}
                                alt="" className='cloud-design' />
                        </div>
                    </Link>
                </div>

            </div>
        </section >
    )
};

export default CardStatics;
